// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Testimonials_anchor__1DYnf","Testimonials":"Testimonials_Testimonials__1rt-C","video":"Testimonials_video__18-2A"};